// @generated
// AUTO-GENERATED by scripts/generate-fhir-terminologies.ts. Do not edit.
// Run: npm run generate:terminologies
// Source: apps/ig/input/resources/value-sets/genders.json
export const URL = 'http://alopexcare.com/fhir/ValueSet/genders';
export const concepts = [
    { code: 'male', display: 'Male', displayUi: 'Male', system: 'http://hl7.org/fhir/administrative-gender' },
    { code: 'female', display: 'Female', displayUi: 'Female', system: 'http://hl7.org/fhir/administrative-gender' },
    { code: 'other', display: 'Other', displayUi: 'Other', system: 'http://hl7.org/fhir/administrative-gender' },
    { code: 'unknown', display: 'Unknown', displayUi: 'Unknown', system: 'http://hl7.org/fhir/administrative-gender' },
];
export function isValidCode(value) {
    return concepts.some((c) => c.code === value);
}
/** Returns the UI display (designation override if present, else canonical display). */
export function getDisplay(code) {
    return concepts.find((c) => c.code === code)?.displayUi ?? '';
}
/**
 * Build a FHIR Coding with the canonical display (NOT displayUi) to preserve
 * server-side terminology-binding validity. Use getDisplay() for UI rendering.
 */
export function toCoding(code) {
    const concept = concepts.find((c) => c.code === code);
    return { system: concept?.system ?? '', code, display: concept?.display ?? '' };
}
